import { ThemeUIStyleObject } from 'theme-ui'

export const styles: Record<string, ThemeUIStyleObject> = {
  warningMessageContainer: {
    flexDirection: 'column',
    background: 'error',
    borderRadius: '10px',
    marginBottom: '15px',
    padding: '15px',
    alignItems: 'center',
    justifyContent: 'center',
  },
}
